/* ==========================================================================
   Midastime — Global JS
   Overlay, accordion, qty selector, cart counter, lazy loading, escape key
   NOTE: Event bus + Cart API are defined inline in theme.liquid <head>
         so they are available before any section JS runs.
   ========================================================================== */

(function () {
  'use strict';

  window.Midastime = window.Midastime || {};

  /* --------------------------------------------------------------------------
     OVERLAY MANAGEMENT
     -------------------------------------------------------------------------- */
  var overlay = document.getElementById('overlay');

  window.Midastime.openOverlay = function () {
    if (overlay) {
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  };

  window.Midastime.closeOverlay = function () {
    if (overlay) {
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  };

  if (overlay) {
    overlay.addEventListener('click', function () {
      window.Midastime.closeOverlay();
      window.Midastime.emit('overlay:click');
    });
  }

  /* --------------------------------------------------------------------------
     4. ACCORDION
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;

    var item = trigger.closest('.accordion__item');
    if (!item) return;

    var isOpen = item.classList.contains('is-open');
    var accordion = item.closest('.accordion');

    // Close siblings if single-open accordion
    if (accordion && !accordion.hasAttribute('data-multi')) {
      var siblings = accordion.querySelectorAll('.accordion__item.is-open');
      siblings.forEach(function (sibling) {
        if (sibling !== item) sibling.classList.remove('is-open');
      });
    }

    item.classList.toggle('is-open', !isOpen);
  });

  /* --------------------------------------------------------------------------
     5. QUANTITY SELECTOR
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-selector__btn');
    if (!btn) return;

    var wrapper = btn.closest('.qty-selector');
    var input = wrapper.querySelector('.qty-selector__input');
    var current = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;

    if (btn.hasAttribute('data-action-minus')) {
      input.value = Math.max(min, current - 1);
    } else if (btn.hasAttribute('data-action-plus')) {
      input.value = Math.min(max, current + 1);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------------------------
     6. CART COUNTER UPDATE
     -------------------------------------------------------------------------- */
  function updateCartCounter() {
    window.Midastime.cart.get().then(function (cart) {
      var counters = document.querySelectorAll('[data-cart-count]');
      counters.forEach(function (counter) {
        counter.textContent = cart.item_count;
        counter.classList.toggle('hidden', cart.item_count === 0);
      });
    });
  }

  window.Midastime.on('cart:updated', updateCartCounter);

  /* --------------------------------------------------------------------------
     7. LAZY LOADING (native fallback)
     -------------------------------------------------------------------------- */
  if ('loading' in HTMLImageElement.prototype) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    lazyImages.forEach(function (img) {
      if (img.dataset.src) img.src = img.dataset.src;
    });
  }

  /* --------------------------------------------------------------------------
     8. ESCAPE KEY HANDLER
     -------------------------------------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      window.Midastime.closeOverlay();
      window.Midastime.emit('escape:pressed');
    }
  });

})();
